import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { FaqSectionService } from '../faq-section.service';
import { FaqSection } from '../faq-section';
import { FaqSectionComponent } from '../faq-section/faq-section.component';

@Component({
    selector: 'app-faq-section-list',
    templateUrl: './faq-section-list.component.html',
    styleUrls: ['./faq-section-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class FaqSectionListComponent implements OnInit {
	constructor(
		private faqSectionService: FaqSectionService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = faqSectionService.statuses
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() faqCategoryId: any;
	faqSections: any;
	faqSection: FaqSection;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'enabled', header: 'Enabled', width: 'auto' },
		{ field: 'displayOrder', header: 'Display Order', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.faqSectionId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-faqSection-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if (this.faqCategoryId) {
				// show only activities that are assigned to this activityProviderId
				let faqCategoryIdFilter = { 'faqCategoryVO.faqCategoryId': { 'value': this.faqCategoryId, 'matchMode': 'in' } };
				Object.assign(event.filters, faqCategoryIdFilter);
			}
			const pageNumber = Math.round(event.first / event.rows);
			this.faqSectionService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.faqSections = res.data.faqSections;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.faqSections = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(faqSection: FaqSection) {
		try {
			this.formLoading = true;
			this.faqSectionService.update(faqSection)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.faqSections.map((faqSection, i) => {
							if (faqSection.faqSectionId === res.data.faqSection.faqSectionId) {
								this.faqSections[i] = res.data.faqSection;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(faqSection: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(faqSection));

			this.formLoading = true;
			this.faqSectionService.delete(faqSection.faqSectionId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.faqSections.splice(this.faqSections.indexOf(faqSection), 1);
						this.recordTotal = this.faqSections.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'FaqSection ' + faqSection.faqSectionId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'FaqSection ' + faqSection.faqSectionId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			faqCategoryId: this.faqCategoryId,
			title: 'Add FaqSection'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(FaqSectionComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addFaqSectionCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(faqSection: FaqSection) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			faqCategoryId: this.faqCategoryId,
			faqSection: faqSection,
			title: 'Edit FaqSection'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(FaqSectionComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateFaqSectionCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteFaqSectionCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addFaqSectionCB(faqSection: FaqSection) {
		console.log('Adding FaqSection: ' + JSON.stringify(faqSection));
		// if we don't have a faqSections array yet...
		if (!this.faqSections) {
			this.faqSections = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.faqSections.unshift(faqSection);

		// no idea what this is but it is required to update the array
		this.faqSections = [...this.faqSections];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'FaqSection ' + faqSection.faqSectionId + ' Added', life: 3000 });
	}

	updateFaqSectionCB(faqSection: FaqSection) {
		console.log('Updating FaqSection: ' + JSON.stringify(faqSection));
		let itemIndex = this.faqSections.findIndex((item: any) => item.faqSectionId === faqSection.faqSectionId);
		this.faqSections[itemIndex] = faqSection;

		// no idea what this is but it is required to update the array
		this.faqSections = [...this.faqSections];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'FaqSection ' + faqSection.faqSectionId + ' Updated', life: 3000 });
	}

	deleteFaqSectionCB(faqSection: FaqSection) {
		console.log('Removing FaqSection: ' + faqSection);
		this.faqSections.splice(this.faqSections.indexOf(faqSection), 1);
		this.recordTotal = this.faqSections.length;

		// no idea what this is but it is required to update the array
		this.faqSections = [...this.faqSections];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'FaqSection ' + faqSection.faqSectionId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.faqSections ? this.first === (this.faqSections.length - this.rows) : true; }
	isFirstPage(): boolean { return this.faqSections ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(faqSection: any) {
		if (faqSection?.status) {
			const status = this.statuses.find((e: any) => e.value == faqSection.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}
}
